import React from 'react';
import { useLocation } from 'react-router-dom';

import EmptyModal from './EmptyModal';
import UnsavedModal from './UnsavedModal';

function WarningModals({ formName, onSave }) {
  const location = useLocation();
  const showUnsaved = location.pathname.includes('/warning/unsaved/');
  const showEmpty = location.pathname.includes('/warning/empty/');

  return (
    <>
      {showUnsaved && <UnsavedModal formName={formName} onSave={onSave} />}
      {showEmpty && <EmptyModal formName={formName} />}
    </>
  );
}

export default WarningModals;
